import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  margin-top: 0px;
`;

export const HeroWrapper = styled.div`
  overflow-x: hidden;
  align-content: center;
  background-color: ${({ $bgColor }) =>
    $bgColor ? themeGet(`colors.${$bgColor}`) : 'transparent'};
  .swiper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: clip;

    .swiper-wrapper {
      display: flex;
      justify-content: flex-start;
      place-items: center;

      .swiper-slide {
        display: flex;
        height: auto;
        justify-content: center;
      }
    }

    .swiper-pagination {
      margin: 1.25rem auto;
    }

    .swiper-pagination-bullet {
      display: inline-block;
      width: 0.75rem;
      height: 0.75rem;
      text-align: center;
      line-height: 0.75rem;
      font-size: 0.75rem;
      opacity: 1;
      background: ${themeGet('colors.bullet-grey')};
    }

    .swiper-pagination-bullet-active {
      background: ${themeGet('colors.esso-red')};
    }

    .swiper-pagination-horizontal {
      bottom: -0.75rem;
    }
  }
`;
